import { useStorageState } from 'react-simplikit';

// Export the type for use in other files
export interface WorkspaceCreationState {
  workspaceName: string;
  language: string;
  companyName?: string;
  jobTitle?: string;
}

export function useWorkspaceCreationStorageState() {
  // Use inline type definition to avoid type inference issues
  return useStorageState<{
    workspaceName: string;
    language: string;
    companyName?: string;
    jobTitle?: string;
  }>('workspaceCreation', {
    defaultValue: {
      workspaceName: '',
      language: '',
    },
  });
}
